module.exports = __webpack_public_path__ + "static/ralph-halloween-e2e9430a6a2bf760fb40f9dc63d5d10e.png";